<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-default ">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12 order-md-1 text-center">
                <h1 class="display-3 text-white">Saiba como reduzir
                  <span>os despertares noturnos do seu bebê.</span>
                </h1>
                <p class="lead  text-white">Aprenda tudo o que você precisa para ter uma noite de sono mais
                  tranquila!</p>
                <div class="btn-wrapper">
                  <a href="#passos" class="btn btn-danger btn-lg">Quero Conhecer</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section id="passos" class="section section section-shaped my-0 overflow-hidden">
      <div class="container py-0">
        <div class="row align-items-center">
          <div class="d-flex">
            <div class="pl-4">
              <h4 class="display-3">Acompanhamento do Sono do Bebê</h4>
            </div>
          </div>
          <div class="pl-4">
            <p class="lead">Esse acompanhamento é baseado no método idealizado pelo médico Dr. Odilo Queiroz,
              pediatra e especialista em sono infantil. Ele possui 4 passos que são essenciais para que você possa
              ajustar a rotina do seu bebê a fim de reduzir os despertares noturnos e assim ter uma noite de sono mais
              tranquila.</p>
            <p class="lead">Como sabemos, cada bebê é único, não existe uma fórmula mágica ou uma receita milagrosa
              que sirva pra todos, o método precisa se adequar à realidade do bebê. Pensando nisso, faremos um
              acompanhamento individual e personalizado para que você possa ajustar o sono do seu bebê conforme as
              necessidades dele.
            </p>
          </div>
          <div class="col-sm-12">
            <br>
            <br>
            <h3>Os quatro passos do sono do bebê</h3>
          </div>
          <div class="col-lg-6 order-lg-1">
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div class="pl-4">
                  <h5 class="title text-primary">Passo 1: Conheça o seu Bebê</h5>
                  <p>Aqui você deve observar quais os sinais de sono do seu bebê e quando eles ocorrem. Assim você já
                    identifica os melhores momentos para colocar o seu bebê para dormir</p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div class="pl-4">
                  <h5 class="title text-default">Passo 2: Descubra as Causas para os Despertares.</h5>
                  <p>Antes de querer reduzir os despertares, primeiro você precisa entender por que ele está acordando.
                    Será fome? Dor? Salto de desenvolvimento? Ou associação?</p>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-6 order-lg-2">
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div class="pl-4">
                  <h5 class="title text-success">Passo 3: Higiene do Sono.</h5>
                  <p>Com base nos conhecimentos dos passos 1 e 2, você saberá o que é preciso ajustar na rotina e no
                    ambiente para proporcionar as melhores condições de sono para o seu bebê.
                    Ajustes que vão deixar o seu bebê bem alimentado, acolhido e seguro, para diminuir cada vez mais o
                    número de despertares.</p>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div class="pl-4">
                  <h5 class="title text-warning">Passo 4: As associações do sono.</h5>
                  <p>Entenda QUANDO e QUAIS associações precisarão ser mantidas, reforçadas ou desfeitas.
                    Esse será o último passo a uma maternidade mais leve</p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-sm">
      <div class="container">
        <div class="row mb-sm">
          <div class="col-lg-12">
            <h2 class="display-3">Com esse acompanhamento, o que terei acesso?</h2>
          </div>
        </div>
        <p class="lead">Além do desafio de 7 dias, você terá acesso a:</p>
        <ul class="lead">
          <li>Chamada de vídeo pelo aplicativo para conhecer melhor quais são os seus principais desafios e também para
            análise de rotina
          </li>
          <li>Suporte para tirar todas as suas dúvidas via WhatsApp</li>
          <li>Documento por escrito com todos os ajustes mencionados na chamada de vídeo para que você possa ter acesso
            sempre que precisar. Muitas vezes no decorrer da nossa conversa, por serem muitos ajustes, alguns pontos
            podem ser esquecidos; então você terá esse material de apoio para consultar sempre que precisar
          </li>
          <li>
            <badge pill type="success">BÔNUS </badge>  <u>Comprando agora</u> você ganha 15 dias de acompanhamento e que farão toda a diferença, pois se o se bebê
            estiver
            em salto de desenvolvimento, este tempo a mais será essencial para poder ajustar a rotina do seu bebê
          </li>
        </ul>
        <div class="btn-wrapper text-center">
          <a href="#pagamento" class="btn btn-danger btn-lg">Me Inscrever Agora</a>
        </div>
        <br>
        <br>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-12">
            <div>
              <h3>E o que é o desafio dos 7 dias?</h3>
              <p class="lead">Esse desafio é a principal ferramenta que as mães utilizam para ajustar a rotina, porque
                ele te mostra quais pontos na rotina precisam ser ajustados e que acabam passando despercebidos para que
                você possa conseguir fazer seu bebê dormir sem despertares noturnos.</p>
              <p class="lead">O sono do bebê é imaturo, por isso ele acorda muitas vezes à noite, mas fazendo os ajustes
                necessários, seguindo os 4 passos, nós conseguiremos proporcionar ao bebê condições para que ele durma
                sem despertares, e se caso houver algum despertar noturno, ele consiga voltar a dormir sozinho e sem
                choro!</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-sm">
      <div class="container">
        <div class="row mb-sm">
          <div class="col-lg-12">
            <h2 class="display-3">Para quem é o acompanhamento?</h2>
          </div>
        </div>
        <p class="lead">Mães de bebê de 0 a 2 anos, que estejam passando pela privação do sono, mães que estão exaustas,
          pois seu bebê acorda a noite toda e mães que já tentaram de tudo, mas seu bebê continua acordando muitas vezes
          à noite.</p>
      </div>
    </section>

    <section class="section section-sm">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <h2 class="display-3">Quem eu sou</h2>
          </div>
        </div>
        <div class="row row-grid mb-sm">
          <div class="col-lg-8" order-md-1>
            <p class="lead">Meu nome é Sílvia Bhering, sou terapeuta do sono do bebê e faço parte do time do Dr. Odilo
              Queiroz.</p>
            <p class="lead">Sou mãe do Gabriel de 1 ano e 10 meses e por um bom tempo passei pela privação do sono e sei
              o quanto é exaustiva a vida de uma mãe que não dorme.</p>
            <p class="lead">Por isso, busco ajudar às mães de bebês de 0 a 2 anos que passam pela privação do sono e que
              queiram reduzir os despertares do seu bebê, podendo assim, proporcionar noites de sono mais
              tranquilas.</p>
          </div>

          <div class="col-lg-4 text-center" order-md-2>
            <img src="img/Silvia-Bhering.png" data-src="img/Silvia-Bhering.png" lazy="loaded" style="width: 200px"
                 alt="Sílvia Bhering" class="img-fluid floating rounded">
          </div>
        </div>
      </div>
    </section>

    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-success shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-300" id="pagamento">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Pagamento Seguro</h2>
            <p class="lead text-white">Seus dados e sua compra estaram 100% protegidos e em ambiente seguro. <br>
              Para isso, os mesmos são inseridos no ambiente do Pagseguro, um meio de pagamento conhecido, fácil e sem
              riscos de
              fraudes ou roubos de dados.
              <br>
              <br>
              Se durante os 7 primeiros dias após a confirmação do pagamento, por qualquer motivo, você desistir, entre
              em contato e terá o dinheiro de volta.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-sm pt-0">
      <div class="container">
        <card gradient="primary mt--300" no-body shadow-size="lg" class="border-0">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-12 text-center mb-sm">
                <h4 class="display-3 text-white">Planos para acompanhamento do sono do bebê</h4>
              </div>
              <div class="row">
                <!-- Free Tier -->
                <div class="col-lg-4">
                  <div class="card mb-5 mb-lg-0">
                    <div class="card-body">
                      <h5 class="card-title text-muted text-uppercase text-center">30 dias de Acompanhamento</h5>
                      <h6 class="card-price text-center">12x de R$59,94 <br><span
                          class="period">Ou à vista de R$597,00</span>
                      </h6>
                      <hr>
                      <ul class="fa-ul">
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>Desafio de 7 dias.</li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>Vídeo chamada para conhecer seus
                          principais
                          desafios através da análise da rotina.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>Suporte via whatsapp.</li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>Análise de rotina por escrito.</li>
                      </ul>
                      <div class="d-grid text-center">
                        <a href="https://pag.ae/7XTDJfFQm" class="btn btn-primary text-uppercase" target="_blank">Quero
                          este plano</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card mb-5 mb-lg-0">
                    <div class="card-body">
                      <h5 class="card-title text-muted text-uppercase text-center">45 dias de Acompanhamento</h5>
                      <h6 class="card-price text-center">12x de R$80,02 <br><span
                          class="period">Ou à vista de R$797,00 </span></h6>
                      <hr>
                      <ul class="fa-ul">
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Desafio de 7 dias.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Vídeo chamada para conhecer seus principais desafios através da análise da rotina.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Suporte via whatsapp.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Análise de rotina por escrito.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Você ganha mais uma análise de rotina através de outro desafio e nova chamada por vídeo para
                          orientações dentro do período contratado.
                        </li>
                      </ul>
                      <div class="d-grid text-center">
                        <a href="https://pag.ae/7XTD_LoTM" class="btn btn-primary text-uppercase" target="_blank">Quero
                          este plano</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title text-muted text-uppercase text-center">60 dias de Acompanhamento</h5>
                      <h6 class="card-price text-center">12x de R$100,10 <br><span
                          class="period">Ou à vista de R$997,00 </span></h6>
                      <hr>
                      <ul class="fa-ul">
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Desafio de 7 dias.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Vídeo chamada para conhecer seus principais desafios através da análise da rotina.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Suporte via whatsapp.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Análise de rotina por escrito.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Você ganha mais uma análise de rotina através de outro desafio e nova chamada por vídeo para
                          orientações dentro do período contratado.
                        </li>
                        <li><span class="fa-li"><i class="fa fa-check"></i></span>
                          Mais 15 dias, totalizando 90.
                        </li>
                      </ul>
                      <div class="d-grid text-center">
                        <a href="https://pag.ae/7XTE1sJ61" class="btn btn-primary text-uppercase" target="_blank">Quero
                          este plano</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <br>
    <br>
    <br>
    <br>
    <section class="section section-sm pt-lg-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center mb-sm">
            <h4 class="display-3">Dúvidas Frequentes</h4>
          </div>
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-primary text-uppercase">SERÁ QUE VAI FUNCIONAR PARA O MEU BEBÊ?</h6>
                  <p class="description mt-3">Sim, pois o atendimento é personalizado e respeitamos a individualidade de
                    cada bebê, adaptando o método à realidade de cada família.</p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-success text-uppercase">NÃO TENHO TEMPO PARA IMPLEMENTAR AS MUDANÇAS NECESSÁRIAS, POIS
                    TRABALHO FORA O DIA TODO, ENTÃO NÃO VOU CONSEGUIR REDUZIR OS DESPERTARES DO MEU BEBÊ?</h6>
                  <p class="description mt-3">Consegue sim, pois outra pessoa, seja babá ou um familiar, poderá ajudar
                    com a rotina do bebê.</p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h6 class="text-warning text-uppercase">JÁ TENTEI DE TUDO E NADA DEU CERTO, SERÁ QUE AINDA É POSSÍVEL
                    REDUZIR OS DESPERTARES NOTURNOS?</h6>
                  <p class="description mt-3">Sim, é possível! Pois irei analisar cada caso e juntas poderemos ajustar a
                    rotina de forma a reduzir esses despertares e proporcionar uma noite de sono mais tranquila.</p>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style>
.pricing .card {
  border: none;
  border-radius: 1rem;
  transition: all 0.2s;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.pricing hr {
  margin: 1.5rem 0;
}

.pricing ul li {
  margin-bottom: 1rem;
}

.pricing .text-muted {
  opacity: 0.7;
}

.pricing .btn {
  opacity: 0.7;
  transition: all 0.2s;
}

/* Hover Effects on Card */

@media (min-width: 992px) {
  .pricing .card:hover {
    margin-top: -.25rem;
    margin-bottom: .25rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
  }

  .pricing .card:hover .btn {
    opacity: 1;
  }
}
</style>